export const mapStandardProductsToPublishedData = ($admin)=>{
    return {
        standardProducts: $admin.$standardProducts.map((standardProduct)=>{
            return {
                entityHashes: standardProduct.entityHashes
            };
        })
    };
};

//# sourceMappingURL=map-standard-products-to-published-data.js.map